let sw_discounts = undefined;
(function($){
  $(document).ready(function(){

    sw_discounts = new SwDiscounts();

    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          if ( $(mutation.addedNodes).find('.ws_Product_Price, .product-teaser2__price, .product-teaser__price').length ) {
            setTimeout(() => {
              sw_discounts.update();
            }, 100);
          }
        }
      }

    });
    observer.observe(document, {
      subtree:true,
      childList:true,
    });
  });
})(jQuery);

class SwDiscounts {

  constructor(){
    const _this = this;

    this.$discounts = jQuery('#discounts .discounts-discount');

    this.update();
  }

  update() {
    const _this = this;
    if ( this.$discounts.length ) {
      $('.ws_Product_Price, .product-teaser2__price, .product-teaser__price, .product-price__price').not('.sw-discount-applied').each(function () {
        let $w = $(this);
        let $w2 = $w;

        if ( $w.is('.no-sw-discount')) {
          return;
        }

        if ( $w.find('.boost-sd__format-currency').length) {
          $w2 = $w.find('.boost-sd__format-currency');
        }

        let price_orig = $w2.text();
        let price = price_orig.replace('$', '').replace(',','');
        price = parseFloat(price);
        let priceNew = price;

        _this.$discounts.each(function () {
          const $d = $(this);
          const discountName = $d.data('name');
          const discount = $d.data('discount');

          priceNew -= price*discount;

        });

        if ( priceNew !== price ) {
          let rounded = priceNew;
          if ( priceNew % 0.01 >= 0.00299) {
            rounded += 0.01;
          }
          rounded = Math.floor(rounded*100)/100;
          console.log(priceNew, priceNew % 0.01, rounded);

          const formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rounded);
          $w2.html('<del>' + price_orig + '</del> ' + formatted);
        }

        $w.addClass('sw-discount-applied');
      });
    }
  }

}

